export default "icons-large-area-print"